"use strict";

exports.__esModule = true;
exports.getDefaultDurationVariant = void 0;
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
var _calculatePreferencesView = require("../../utils/calculatePreferencesView/calculatePreferencesView");
const getDefaultDurationVariant = ({
  serviceOptionsAndVariants,
  bookingsSettings,
  experiments,
  openedBy,
  service,
  queryParams
}) => {
  var _serviceOptionsAndVar;
  if (!serviceOptionsAndVariants) {
    return undefined;
  }
  const variants = (_serviceOptionsAndVar = serviceOptionsAndVariants.variants) == null ? void 0 : _serviceOptionsAndVar.values;
  if (!variants || variants.length === 0) {
    return undefined;
  }
  const isBookFlowSettingsEnabled = (0, _bookingsCalendarCatalogViewerMapper.isBookFlowSettingsEnabled)({
    experiments,
    bookingsSettings
  });
  const preferencesView = (0, _calculatePreferencesView.calculatePreferencesViewForAppointment)({
    service,
    bookingsSettings,
    serviceOptionsAndVariants,
    openedBy,
    queryParams
  });
  const variantDisplayOnPreferencesModal = isBookFlowSettingsEnabled && preferencesView[_calculatePreferencesView.PreferenceType.DYNAMIC_PRICE] === _calculatePreferencesView.DisplayTarget.PREFERENCES_MODAL;
  if (!variantDisplayOnPreferencesModal || !(0, _bookingsCalendarCatalogViewerMapper.isDurationVariant)(serviceOptionsAndVariants)) {
    return undefined;
  }
  return variants[0];
};
exports.getDefaultDurationVariant = getDefaultDurationVariant;
//# sourceMappingURL=getDefaultDurationVariant.js.map